module.exports = __webpack_public_path__ + "static/img/empty.b7f2404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/empty.png
// module id = fakP
// module chunks = 1